var map = {
	"./da_DK.json": 299,
	"./de_DE.json": 769,
	"./en_GB.json": 175,
	"./en_US.json": 19,
	"./es_ES.json": 976,
	"./fr_FR.json": 462,
	"./lt.json": 747,
	"./nl_NL.json": 166,
	"./pt_PT.json": 405,
	"./sv_SE.json": 310,
	"./template.json": 656
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 495;